import { render, staticRenderFns } from "./refundRecord.vue?vue&type=template&id=2b0b8132&scoped=true&"
import script from "./refundRecord.vue?vue&type=script&lang=js&"
export * from "./refundRecord.vue?vue&type=script&lang=js&"
import style0 from "./refundRecord.vue?vue&type=style&index=0&id=2b0b8132&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b8132",
  null
  
)

export default component.exports